import { PERMISSION_GROUPS } from "../utils/permissions";


/**
 * Route configuration with associated permissions
 */
export const ROUTE_CONFIG = {
  // Public routes (no authentication required)
  PUBLIC: {
    path: "/",
    permissions: [],
    exact: true
  },
  LOGIN: {
    path: "/login",
    permissions: [],
    exact: true
  },
  SIGNUP_WITH_PLAN: {
    path: "/signup/:planName",
    permissions: [],
    exact: true
  },

  // Protected routes (require authentication and specific permissions)
  // Admin landing page - the snapshot every admin lands on after login
  // (see ADMIN_LANDING_LOOKUP_PATHS in core/utils/permissions.ts).
  ADMIN_OVERVIEW: {
    path: "/admin-overview",
    permissions: ['overview.view'],
    exact: true
  },
  USER_MANAGEMENT: {
    path: "/user-management",
    permissions: [...PERMISSION_GROUPS.USER_MANAGEMENT, ...PERMISSION_GROUPS.ROLE_MANAGEMENT],
    exact: true
  },
  USERS_LIST: {
    path: "/users-list",
    permissions: PERMISSION_GROUPS.USER_MANAGEMENT,
    exact: true
  },
  USER_CREDITS: {
    path: "/user-credits",
    permissions: ['users.view_credits'],
    exact: true
  },
  USER_ROLES: {
    path: "/users-roles",
    permissions: PERMISSION_GROUPS.ROLE_MANAGEMENT,
    exact: true
  },
  EMAIL_SETTINGS: {
    path: "/email-settings",
    permissions: [
      'email_pattern.create',
      'email_pattern.edit',
      'email_pattern.delete',
      'verification_settings.view',
      'verification_settings.edit'
    ],
    exact: true
  },
  EMAIL_PATTERNS: {
    path: "/email-patterns",
    permissions: [
      'email_pattern.create',
      'email_pattern.edit',
      'email_pattern.delete'
    ],
    exact: true
  },
  NETBOX_MANAGEMENT: {
    path: "/netbox-management",
    permissions: [
      'server_list.create',
      'server_list.edit',
      'server_list.delete',
      'server_list.view',
      'server_ip.create',
      'server_ip.edit',
      'server_ip.delete'
    ],
    exact: true
  },
  SERVER_IP_LIST: {
    path: "/server-ips-list",
    permissions: [
      'server_list.create',
      'server_list.edit',
      'server_list.delete'
    ],
    exact: true
  },
  SERVER_IP_DETAILS: {
    path: "/server-ip-details",
    permissions: [
      'server_list.create',
      'server_list.edit',
      'server_list.delete'
    ],
    exact: true
  },
  SERVER_IP_VIEW: {
    path: "/server-ip-details/view/:id",
    permissions: [
      'server_list.create',
      'server_list.edit',
      'server_list.delete'
    ],
    exact: true
  },
  SERVER_IP_STATS: {
    path: "/server-ip-details/stats/:id",
    permissions: [
      'server_list.create',
      'server_list.edit',
      'server_list.delete'
    ],
    exact: true
  },
  SERVER_IP_STATS_OVERALL: {
    path: "/server-ip-details/stats",
    permissions: [
      'server_list.create',
      'server_list.edit',
      'server_list.delete'
    ],
    exact: true
  },
  OVH_FLEET_STATUS: {
    path: "/ovh-fleet-status",
    permissions: [
      'server_list.create',
      'server_list.edit',
      'server_list.delete'
    ],
    exact: true
  },
  SYSTEM_EVENT_LOGS: {
    path: "/system-event-logs",
    permissions: [
      'server_list.create',
      'server_list.edit',
      'server_list.delete',
      'server_list.view'
    ],
    exact: true
  },
  NETBOX_EVENT_ERRORS: {
    path: "/netbox-event-errors",
    permissions: [
      'server_list.create',
      'server_list.edit',
      'server_list.delete'
    ],
    exact: true
  },
  EMAIL_VERIFIER_STATS: {
    path: "/email-verifier-stats",
    permissions: [
      'server_list.create',
      'server_list.edit',
      'server_list.delete',
      'server_list.view'
    ],
    exact: true
  },
  BLOCKED_IPS: {
    path: "/blocked-ips",
    permissions: [
      'server_ip.create',
      'server_ip.edit',
      'server_ip.delete'
    ],
    exact: true
  },
  API_HISTORY: {
    path: "/api-history",
    permissions: ['api_history.view_file_stats'],
    exact: true
  },
  ADMIN_AUDIT_LOGS: {
    path: "/admin-audit-logs",
    permissions: ['users.view_audit_logs'],
    exact: true
  },
  USER_PROFILE: {
    path: "/user-profile/:userId",
    permissions: [
      'users.view_audit_logs',
      'users.view_credits',
      'users.view_file_reports',
      'users.edit',
      'users.assign_credits',
      'users.change_plan',
      'attribution.view'
    ],
    exact: true
  },
  BILLING_MANAGEMENT: {
    path: "/billing-management",
    permissions: [...PERMISSION_GROUPS.BILLING_MANAGEMENT, ...PERMISSION_GROUPS.COUPON_MANAGEMENT],
    exact: true
  },
  ADMIN_PLANS: {
    path: "/admin/plans",
    permissions: [],
    exact: true
  },
  HUBSPOT_INTEGRATIONS: {
    path: "/hubspot-integrations",
    permissions: ['hubspot_integration.view'],
    exact: true
  },
  EMAIL_OPERATIONS: {
    path: "/email-operations",
    permissions: PERMISSION_GROUPS.EMAIL_OPERATIONS,
    exact: true
  },
  BULK_EMAIL_VERIFY: {
    path: "/bulk-email-verify",
    permissions: PERMISSION_GROUPS.EMAIL_OPERATIONS,
    exact: true
  },
  BULK_EMAIL_FINDER: {
    path: "/bulk-email-finder",
    permissions: PERMISSION_GROUPS.EMAIL_OPERATIONS,
    exact: true
  },
  VERIFY_EMAIL: {
    path: "/verify-email",
    permissions: [
      'verify_email.create',
      'verify_email.view_file_stats'
    ],
    exact: true
  },
  EMAIL_FINDER: {
    path: "/email-finder",
    permissions: [
      'finder_email.create',
      'finder_email.view_file_stats'
    ],
    exact: true
  },
  LOGS_HISTORY: {
    path: "/logs-history",
    permissions: ['log_history.view'],
    exact: true
  },
  EMAIL_VERIFIER: {
    path: "/email-verifier",
    permissions: [],
    exact: true
  },
  EMAIL_VERIFIER_EMAIL_DETAILS: {
    path: "/email-verifier/email/:id",
    permissions: [],
    exact: true
  },
  EMAIL_VERIFIER_RESULTS: {
    path: "/email-verifier/results/:id",
    permissions: [],
    exact: true
  },
  NOT_AUTHORIZED: {
    path: "/not-authorized",
    permissions: [],
    exact: true
  },
  COUPONS_LIST: {
    path: "/coupons",
    permissions: PERMISSION_GROUPS.COUPON_MANAGEMENT,
    exact: true
  },
  CREATE_COUPON: {
    path: "/coupons/create",
    permissions: ['coupon.create'],
    exact: true
  },
  EDIT_COUPON: {
    path: "/coupons/:id/edit",
    permissions: ['coupon.edit'],
    exact: true
  },
  COUPON_USAGE: {
    path: "/coupons/:id/usage",
    permissions: ['coupon.view_usage'],
    exact: true
  },
};

/**
 * Gets all route paths that are accessible with the given permissions
 * @param permissions User's permissions array
 * @returns Array of accessible route paths
 */
export const getAccessibleRoutes = (permissions: string[]): string[] => {
  return Object.values(ROUTE_CONFIG)
    .filter(route => 
      route.permissions.length === 0 || 
      route.permissions.some((p: string) => permissions.includes(p))
    )
    .map(route => route.path);
};

/**
 * Checks if a route is accessible with the given permissions
 * @param path Route path to check
 * @param permissions User's permissions array
 * @returns boolean
 */
export const isRouteAccessible = (path: string, permissions: string[]): boolean => {
  const route = Object.values(ROUTE_CONFIG).find(r => r.path === path);
  if (!route) return false;
  
  return route.permissions.length === 0 || 
         route.permissions.some((p: string) => permissions.includes(p));
};
